import SkillsTabs from "./SkillsTabs";

const Skills = () => {
    return (
        <div id="Skills">
            <h1>Skills</h1>
            <SkillsTabs />
            {/* <progress value="25" max={100}>25%</progress> */}
        </div> 
    );
}

export default Skills